import React from 'react';
import { connect } from 'react-redux';
import { shiftNotification } from 'shared/actions/notifications';
import { getDisplayName } from 'shared/helpers/common';
import PropTypes from 'prop-types';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

const mapStateToProps = ({ notifications }) => ({ messageQueue: notifications });
const mapDispatchToProps = { shift: shiftNotification };

const withNotifications = WrappedComponent =>
  connect(mapStateToProps, mapDispatchToProps)(
    class extends React.Component {
      static displayName = `withNotifications(${getDisplayName(WrappedComponent)})`;

      static propTypes = {
        messageQueue: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
            type: PropTypes.string,
          }),
        ).isRequired,
        shift: PropTypes.func.isRequired,
        duration: PropTypes.number,
      };
      static defaultProps = {
        duration: 4000,
      };

      state = {
        activeMessage: null,
      };

      componentDidMount() {
        if (!this.state.activeMessage) {
          this.tick();
        }
      }

      componentDidUpdate(prevProps) {
        if (
          prevProps.messageQueue.length < this.props.messageQueue.length &&
          !this.state.activeMessage
        ) {
          this.tick();
        }
      }

      tick = () => {
        const { duration, shift } = this.props;
        const lastMessage = this.props.messageQueue[0];

        if (lastMessage) {
          this.setState({ activeMessage: lastMessage }, () => {
            delay(duration).then(() => {
              shift();
              this.setState({ activeMessage: null }, () => {
                delay(duration / 4).then(() => this.tick());
              });
            });
          });
        }
      };

      render () {

        return <WrappedComponent activeMessage={this.state.activeMessage} {...this.props} />;
      }
    },
  );

export default withNotifications;



// WEBPACK FOOTER //
// ./src/shared/hocs/withNotifications.js